import {Component, OnInit} from '@angular/core';
import {TranslateService} from 'ng2-translate';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: []
})
export class AboutUsComponent implements OnInit {
  aboutUs: any = {};
  htmgtlString: string;
  features: any = {};

  constructor(private translateService: TranslateService) {
  }

  ngOnInit() {
    this.aboutUs = JSON.parse(localStorage.getItem('aboutUs'));
    // this.features=this.aboutUs.product_features;
    // this.features=this.features.replace("&lt;li&gt;","<li>");
    // this.features = this.features.replace("&lt;/li&gt;","</li>");
    // console.log('hello pk :', this.aboutUs);
    // this.feature = this.aboutUs.product_features;
    // this.features = this.feature.replace("&lt;/li&gt;","</li>");
    this.features = this.aboutUs.product_features;
    // this.htmgtlString = this.features;
    // this.htmgtlString = '' +
    //   '<div id="&lt;lol&gt;">' +
    //   '<span title="&lt;&;&lt; &lt;&gt;&lt; &lt;&gt;&lt; fish">hover for fishies</span>' +
    //   '</div>';
    // while (this.htmgtlString.match(/="([^"])\&[gl]t;([^"])"/g)) {
    //   this.htmgtlString = this.htmgtlString.replace(/="([^"])\&gt;([^"])"/g, '="$1>$2"')
    //     .replace(/="([^"])\&lt;([^"])"/g, '="$1<$2"');
    // }
  }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/about-us/about-us.component.ts